import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, FlameIcon, GlobeIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { offerPerks, offerStack } from '../../data/content';
const TOTAL_SPOTS = 50;
export function Offer() {
  const [spotsLeft, setSpotsLeft] = useState(7);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSpotsLeft(s => s > 3 ? s - 1 : s);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const filled = (TOTAL_SPOTS - spotsLeft) / TOTAL_SPOTS * 100;
  return <section id="offer" className="bg-brand-900 px-4 py-16 sm:py-20" data-id="element-172" data-mp="3jxmcnh7j4jww">
      <div className="mx-auto max-w-2xl" data-id="element-173" data-mp="3nwbzs1iddftq">
        <h2 className="text-center font-serif text-[30px] leading-tight sm:text-5xl font-extrabold text-white" data-id="element-174" data-mp="3svyfchlo785p">
          Here’s everything you receive <em className="text-brand-200" data-id="element-175" data-mp="1qf2vcbub4v5">today</em>
        </h2>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white shadow-[0_30px_60px_-20px_rgba(0,0,0,0.5)]" data-id="element-176" data-mp="1kl8aqym9djbu">
          <div className="bg-cta px-5 py-3 text-center text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-177" data-mp="1fm40e4nllfjx">
            Special launch offer
          </div>
          <div className="p-5 sm:p-8" data-id="element-178" data-mp="1bmmsl4kp86bl">
            <ul className="divide-y divide-brand-100" data-id="element-179" data-mp="16mgzrl2p0drx">
              {offerStack.map(item => <li key={item.label} className="flex items-start justify-between gap-4 py-3.5" data-id="element-180" data-mp="23c7sberfbqv3">
                  <span className="flex items-start gap-2.5 text-[15px] sm:text-base font-semibold text-ink" data-id="element-181" data-mp="1za4ewkl72c76">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-182" data-mp="1uimebxn32dmq" />
                    {item.label}
                  </span>
                  <s className="shrink-0 text-[15px] text-muted" data-id="element-183" data-mp="2mzp0zccn9pko">${item.value}</s>
                </li>)}
            </ul>

            <div className="mt-4 flex items-center justify-between rounded-xl bg-brand-50 px-4 py-3" data-id="element-184" data-mp="2i8gpmarr7u4v">
              <span className="font-bold text-ink" data-id="element-185" data-mp="316sc6gm079qf">Total value</span>
              <s className="text-lg font-bold text-danger" data-id="element-186" data-mp="3653m0rcatk8n">$268</s>
            </div>

            <div className="mt-8 text-center" data-id="element-187" data-mp="2sdf6ee2ucdmx">
              <p className="text-[15px] text-muted" data-id="element-188" data-mp="2scnna2qfk8dj">
                You don’t pay $268. You don’t pay $97. You don’t even pay $47.
              </p>
              <p className="mt-4 text-sm font-bold uppercase tracking-wider text-brand-700" data-id="element-189" data-mp="2if95nzsrtdjn">Today you get everything for</p>
              <p className="mt-1 font-serif text-[88px] sm:text-[110px] font-extrabold leading-none text-brand-800" data-id="element-190" data-mp="2necb3lcnxls5">
                <span className="align-top text-4xl sm:text-5xl" data-id="element-191" data-mp="29fmdm4lxlk39">$</span>27
              </p>
              <p className="mt-2 text-sm font-semibold text-muted" data-id="element-192" data-mp="2dgo682lcexw9">One-time payment · USD</p>
              <p className="mx-auto mt-4 flex max-w-sm items-center justify-center gap-2 rounded-xl bg-brand-50 px-4 py-2.5 text-[14px] font-medium text-brand-800" data-id="element-193" data-mp="7nzns6drzv8d">
                <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-194" data-mp="1w6at65sm30ro" />
                Currency is converted automatically to your local currency at checkout.
              </p>
            </div>

            <div className="mt-8 rounded-2xl border-2 border-danger/25 bg-[#FDF3F3] p-4" data-id="element-195" data-mp="25w3tubr7tvh5">
              <p className="flex items-center gap-2 text-[15px] font-bold text-danger" data-id="element-196" data-mp="215nhkuz4sfwd">
                <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-197" data-mp="213u52z1u71gg" />
                Only {spotsLeft} spots left at the promotional price
              </p>
              <div className="mt-3 h-4 overflow-hidden rounded-full bg-danger/15" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Launch spots claimed" data-id="element-198" data-mp="2auowsixuqt9a">
                <motion.div className="h-full rounded-full bg-danger" initial={{
                width: '60%'
              }} whileInView={{
                width: `${filled}%`
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.3,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-199" data-mp="ujb394a5vd2o" />
              </div>
              <p className="mt-2 text-xs font-semibold text-ink/70" data-id="element-200" data-mp="10wyxkd2vgqbx">
                {Math.round(filled)}% claimed — price goes back to regular value when spots run out.
              </p>
            </div>

            <div className="mt-8" data-id="element-201" data-mp="89kv5zgen2kf">
              <CtaButton label="Get it now for $27" data-id="element-202" data-mp="8amhj02vfbhg" />
            </div>

            <ul className="mt-6 grid grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-203" data-mp="d8xq77hfjfy3">
              {offerPerks.map(p => <li key={p} className="flex items-center gap-2 text-sm font-medium text-ink" data-id="element-204" data-mp="i67fmn4tjrlx">
                  <CheckIcon className="h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-205" data-mp="myhc6m0fvpx6" />
                  {p}
                </li>)}
            </ul>
            <p className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs font-semibold text-muted" data-id="element-206" data-mp="3qm0ukxji4v0v">
              <span className="flex items-center gap-1.5" data-id="element-207" data-mp="3j1yj4gmzev00">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-208" data-mp="3e4gdaz49gvw8" /> Secure checkout
              </span>
              <span className="flex items-center gap-1.5" data-id="element-209" data-mp="394kfjhm5q0p4">
                <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-210" data-mp="3976lxdxbaa5r" /> 7-Day Guarantee
              </span>
            </p>

            <Countdown data-id="element-211" data-mp="3045m1uz1hfaj" />
          </div>
        </div>
      </div>
    </section>;
}